import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { View } from 'react-native';

var QLinearGradient = /*#__PURE__*/function (_Component) {
  _inherits(QLinearGradient, _Component);

  var _super = _createSuper(QLinearGradient);

  function QLinearGradient() {
    _classCallCheck(this, QLinearGradient);

    return _super.apply(this, arguments);
  }

  _createClass(QLinearGradient, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$start = _this$props.start,
          start = _this$props$start === void 0 ? {
        x: 0,
        y: 0
      } : _this$props$start,
          _this$props$end = _this$props.end,
          end = _this$props$end === void 0 ? {
        x: 0,
        y: 1
      } : _this$props$end,
          locations = _this$props.locations,
          colors = _this$props.colors,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          children = _this$props.children;

      if (colors && locations && colors.length !== locations.length) {
        console.warn('LinearGradient colors and locations props should be arrays of the same length');
        return null;
      } // colors 至少要设置两种颜色


      if (!Array.isArray(colors) || colors.length === 0 || colors.length === 1) {
        console.warn('LinearGradient colors length must be array more than two object');
        return null;
      } // start=end的时候打警告处理


      if (start && end && start.x === end.x && start.y === end.y) {
        console.warn('LinearGradient start should not equal to end');
        return null;
      } // locations的范围是 0~1


      var isLocationsCorrect = true;

      if (Array.isArray(locations)) {
        locations.forEach(function (v) {
          if (v < 0 || v > 1) {
            isLocationsCorrect = false;
          }
        });
      }

      if (!isLocationsCorrect) {
        console.warn('LinearGradient locations object must be 0~1');
        return null;
      }

      var vec = [end.x - start.x, start.y - end.y];
      var radina = Math.atan2(vec[0], vec[1]);
      var angle = 180 * radina / Math.PI;
      var realLocations = locations || colors.map(function (color, i) {
        return 1 / (colors.length - 1) * i;
      });
      var colorStrings = colors.map(function (color, i) {
        return "".concat(color, " ").concat(Math.round(realLocations[i] * 100), "%");
      }).join(', ');
      return /*#__PURE__*/React.createElement(View, {
        style: [style, {
          backgroundImage: "linear-gradient(".concat(angle, "deg, ").concat(colorStrings, ")")
        }]
      }, children);
    }
  }]);

  return QLinearGradient;
}(Component);

export default QLinearGradient;